import React, { useState, useEffect } from "react";

import "../Header/styles.css"
import api from "../Services/api";
import "../../../src/assets/css/dist/numeros.dist.css";
const Vidas = () => {

  // const [vidas, setVidas] = useState<any[]>([]);
  const [tipos, setTipos] = useState<any>();
  // const [lifes, setLifes] = useState<any[]>([]);
  const [planoA, setPlanoA] = useState<any>();
  const [planoB, setPlanoB] = useState<any>();
  const [planoTaesa, setPlanoTaesa] = useState<any>();
  
  useEffect(() => {
    api
      .get("/ObterInformacoesPlano")
      .then((response) => {
        response.data.results.map((item: any) => {
          if (item.NomePlano === "Plano A") {
            setPlanoA([item.Ativos,item.Assistidos, item.Pensionistas, item.Licenciados, item.Autopatrocinados,item.BPD, item.Peculio ]);
          }
          if (item.NomePlano === "Plano B") {
            setPlanoB([item.Ativos,item.Assistidos, item.Pensionistas, item.Licenciados, item.Autopatrocinados,item.BPD, item.Peculio ]);          
          }
          if (item.NomePlano === "Plano Taesa") {            
            setPlanoTaesa([item.Ativos,item.Assistidos, item.Pensionistas, item.Licenciados, item.Autopatrocinados,item.BPD, item.Peculio ]);
          }
          return true;
        })
        setTipos(["Em atividades nas patrocinadores", "Assistidos", "Pensionistas", "Licenciados", "Autopatrocinados", "BPD", "Peculio"]);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, []);
 
 
  let sumA = planoA?.reduce((acc : any, curr : any) => acc + curr, 0);
  let sumB = planoB?.reduce((acc : any, curr : any) => acc + curr, 0);
  let sumTaesa = planoTaesa?.reduce((acc : any, curr : any) => acc + curr, 0);
  let sum = sumA + sumB + sumTaesa; 

  return (

    <div className="page-numeros__table">
      <div className="line mb-6">
        <p><strong> {sum.toLocaleString('pt-BR')} vidas </strong> <br /> Atualmente, ocupamos a 9ª do ranking da Abrapp - Associação Brasileira das Entidades Fechadas de Previdência Complementar. </p>
      </div>

      <div className="table d-none d-lg-block">
        <table className="mb-4">
          <thead>
            <tr>
              <td> Tipo</td>
              <td> Plano  A </td>
              <td > Plano  B </td>
              <td > Plano Taesaprev </td>
            </tr>
          </thead>
          <tbody>


            {tipos?.map((item: any,index:any) => {
              return (
                <tr>
                  <td> {item}</td>
                  <td> {planoA[index].toLocaleString('pt-BR')}</td>
                  <td> {planoB[index].toLocaleString('pt-BR')}</td>
                  <td> {planoTaesa[index].toLocaleString('pt-BR')}</td>
                   
                </tr>
              )
            })}

          </tbody>
          <tfoot>
            <tr>
              <td> Total </td>
              <td> {sumA?.toLocaleString('pt-BR')} </td>
              <td> {sumB?.toLocaleString('pt-BR')} </td>
              <td> {sumTaesa?.toLocaleString('pt-BR')} </td>

            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );

};
export default Vidas;